import React, { createContext, useContext, useMemo, useState } from 'react';

const VectorContext = createContext();

export function VectorProvider({ children }) {
  const [vectors, setVectors] = useState([]);
  const [activeVecId, setActiveVecId] = useState(null);
  const value = useMemo(
    () => ({ vectors, setVectors, activeVecId, setActiveVecId }),
    [vectors, activeVecId]
  );
  return <VectorContext.Provider value={value}>{children}</VectorContext.Provider>;
}

export function useVectors() {
  const ctx = useContext(VectorContext);
  if (!ctx) throw new Error('useVectors must be used within VectorProvider');
  return ctx;
}
